import React from "react";
import { useSnowplowContext } from "../../analytics/snowplow";
import styles from "./styles.modules.scss";

type HtmlType = { html: string };

const OUTBOUND_LINK_MARKER = "OpenWeb?url=";

export const Html = ({ html }: HtmlType) => {
    const { trackLinkClick } = useSnowplowContext();

    const trackOutboundLink = (event: React.MouseEvent) => {
        try {
            const target = event.target as HTMLAnchorElement;
            if (
                target.nodeName === "A" &&
                target.href.includes(OUTBOUND_LINK_MARKER)
            ) {
                const urlStart =
                    target.href.indexOf(OUTBOUND_LINK_MARKER) +
                    OUTBOUND_LINK_MARKER.length;
                const urlEnd =
                    // "%27" is '
                    target.href.lastIndexOf("%27") ?? target.href.length;

                const url = decodeURIComponent(
                    target.href.substring(urlStart, urlEnd),
                );
                const label = target.textContent ?? undefined;

                trackLinkClick({ url, label });
            }
        } catch {
            // no need to do anything, analytics just will not be tracked
        }
    };

    return (
        <div
            className={`html ${styles.html}`}
            dangerouslySetInnerHTML={{
                __html: html,
            }}
            onClick={trackOutboundLink}
        />
    );
};
